import { ApplicationConfig, provideZonelessChangeDetection } from '@angular/core';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withJsonpSupport } from '@angular/common/http';
import {
  CalendarDateFormatter,
  CalendarMomentDateFormatter,
  DateAdapter as DateAdapter2,
  MOMENT
} from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/moment';
import moment from 'moment/moment';
import { AuthInterceptor } from './auth/auth.interceptor';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { EIO_DATE_FORMATS_LONG } from './consts/localization.const';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { environment } from '../environments/environment';
import { provideServiceWorker } from '@angular/service-worker';
import { provideRouter, withComponentInputBinding, withViewTransitions } from '@angular/router';
import { routes } from './app.routes';
import { MAT_TABS_CONFIG } from '@angular/material/tabs';
import { MAT_SELECT_CONFIG } from '@angular/material/select';
import { provideAnimations } from '@angular/platform-browser/animations';

export function momentAdapterFactory() {
  return adapterFactory(moment);
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),
    provideAnimations(),
    provideRouter(routes, withComponentInputBinding(), withViewTransitions()),
    provideHttpClient(withInterceptorsFromDi(), withJsonpSupport()),
    provideServiceWorker('ngsw-worker.js', {
      enabled: environment.production,
      // Register the ServiceWorker as soon as the app is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000'
    }),
    {
      provide: MOMENT,
      useValue: moment
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
    {
      provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS,
      useValue: { useUtc: false, strict: true }
    },
    {
      provide: MAT_DATE_FORMATS,
      useValue: EIO_DATE_FORMATS_LONG
    },
    {
      provide: MAT_DATE_LOCALE,
      useValue: 'en-AU'
    },
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: { floatLabel: 'always', appearance: 'outline' }
    },
    {
      provide: MAT_TABS_CONFIG,
      useValue: { alignTabs: 'start', stretchTabs: false }
    },
    {
      provide: MAT_SELECT_CONFIG,
      useValue: { hideSingleSelectionIndicator: true }
    },
    {
      provide: DateAdapter2,
      useFactory: momentAdapterFactory
    },
    {
      provide: CalendarDateFormatter,
      useClass: CalendarMomentDateFormatter
    }
  ]
};
